import { render } from "./ContactEnd.vue?vue&type=template&id=ae79e314"
import script from "./ContactEnd.vue?vue&type=script&lang=js"
export * from "./ContactEnd.vue?vue&type=script&lang=js"
script.render = render

export default script